import { SvgIcon } from '@mui/material';

export function CancelIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 30,
    width: 14,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="12.256"
      height="12.2"
      viewBox="0 0 12.256 12.2"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-delete"
        d="M18.265,6.97a.705.705,0,0,0-.492.217l-4.791,4.791L8.191,7.187a.705.705,0,1,0-1,1l4.791,4.791L7.194,17.766a.705.705,0,1,0,1,1l4.791-4.791,4.791,4.791a.705.705,0,1,0,1-1l-4.791-4.791L18.77,8.185a.705.705,0,0,0-.5-1.214Z"
        transform="translate(-6.87 -6.87)"
        fill="currentColor"
        stroke="currentColor"
      />
    </SvgIcon>
  );
}

export function WhatsAppChatIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 20.062,
    width: 20.062,
    color: '#fff',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20.062"
      height="20.062"
      viewBox="0 0 20.062 20.062"
      {...rest}
      sx={rootSx}
    >
       <g id="Group_121373" data-name="Group 121373" transform="translate(-37.988 3.016)">
    <path id="icons8-chat-message" d="M14.031,4A10.043,10.043,0,0,0,4,14.029a9.938,9.938,0,0,0,1.134,4.547L4.047,22.47a1.28,1.28,0,0,0,1.546,1.546l3.9-1.087a9.936,9.936,0,0,0,4.542,1.132A10.031,10.031,0,0,0,14.031,4Zm0,1.5A8.527,8.527,0,1,1,9.889,21.48a.752.752,0,0,0-.568-.068l-3.7,1.033,1.034-3.7a.752.752,0,0,0-.068-.569A8.522,8.522,0,0,1,14.031,5.5ZM9.768,11.521a.752.752,0,1,0,0,1.5h8.527a.752.752,0,1,0,0-1.5Zm0,3.511a.752.752,0,1,0,0,1.5h6.52a.752.752,0,1,0,0-1.5Z" transform="translate(33.988 -7.014)" fill="#fdffff"/>
  </g>
    </SvgIcon>
  );
}

export function EmojiIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 16,
    width: 16,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...rest}
      sx={rootSx}
    >
      <g id="Vector">
        <path
          id="Path_344"
          data-name="Path 344"
          d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM5.2,7.2A1.2,1.2,0,1,0,4,6,1.2,1.2,0,0,0,5.2,7.2Zm5.6,0A1.23,1.23,0,0,0,12,6,1.2,1.2,0,1,0,9.6,6a1.23,1.23,0,0,0,1.2,1.2Zm1.76,2.4A4.951,4.951,0,0,1,8,12.8,4.951,4.951,0,0,1,3.44,9.6ZM1.6,8A6.4,6.4,0,1,0,8,1.6,6.4,6.4,0,0,0,1.6,8Z"
          fill="#3b3b3b"
          fill-rule="evenodd"
        />
      </g>
    </SvgIcon>
  );
}

export function MicIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 20,
    width: 20,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...rest}
      sx={rootSx}
    >
      <path
        id="Path_503"
        data-name="Path 503"
        d="M10,11.474a2.255,2.255,0,0,0,2.136-2.368l.007-4.737A2.261,2.261,0,0,0,10,2,2.261,2.261,0,0,0,7.857,4.368V9.1A2.261,2.261,0,0,0,10,11.474ZM9.143,4.289A.908.908,0,0,1,10,3.342a.908.908,0,0,1,.857.947L10.85,9.184a.858.858,0,1,1-1.707,0ZM13.786,9.1A3.9,3.9,0,0,1,10,13.132,3.9,3.9,0,0,1,6.214,9.105H5a5.349,5.349,0,0,0,4.286,5.3V17h1.429V14.411A5.336,5.336,0,0,0,15,9.1Z"
        fill="#3b3b3b"
      />
      <path id="Path_504" data-name="Path 504" d="M0,0H20V20H0Z" fill="none" />
    </SvgIcon>
  );
}

export function AIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 20,
    width: 20,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...rest}
      sx={rootSx}
    >
      <g
        id="Group_121228"
        data-name="Group 121228"
        transform="translate(-287 -763)"
      >
        <path
          id="A"
          d="M7.109-4.7,5.367-9.773,3.516-4.7ZM4.555-11.477H6.313L10.477,0h-1.7L7.609-3.437H3.07L1.828,0H.234Z"
          transform="translate(292 779)"
          fill="#3b3b3b"
        />
        <rect
          id="Rectangle_59740"
          data-name="Rectangle 59740"
          width="20"
          height="20"
          transform="translate(287 763)"
          fill="none"
        />
      </g>
    </SvgIcon>
  );
}

export function AttachIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 20,
    width: 20,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
      {...rest}
      sx={rootSx}
    >
      <path
        id="Path_501"
        data-name="Path 501"
        d="M16.5,5.091V14.5c0,1.808-1.79,3.273-4,3.273s-4-1.465-4-3.273V4.273A2.308,2.308,0,0,1,11,2.227a2.308,2.308,0,0,1,2.5,2.045v8.591a.926.926,0,0,1-1,.818.926.926,0,0,1-1-.818V5.091H10v7.773a2.308,2.308,0,0,0,2.5,2.045A2.308,2.308,0,0,0,15,12.864V4.273C15,2.465,13.21,1,11,1S7,2.465,7,4.273V14.5C7,16.987,9.46,19,12.5,19S18,16.987,18,14.5V5.091Z"
        transform="translate(-2.154)"
        fill="#3b3b3b"
      />
      <path id="Path_502" data-name="Path 502" d="M0,0H20V20H0Z" fill="none" />
    </SvgIcon>
  );
}

export function RxAuditCardArrowIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 24,
    width: 24,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...rest}
      sx={rootSx}
    >
      <g
        id="Group_122205"
        data-name="Group 122205"
        transform="translate(-315 -270)"
      >
        <g
          id="Ellipse_129965"
          data-name="Ellipse 129965"
          transform="translate(315 270)"
          fill="none"
          stroke="#888"
          stroke-width="1"
        >
          <circle cx="12" cy="12" r="12" stroke="none" />
          <circle cx="12" cy="12" r="11.5" fill="none" />
        </g>
        <path
          id="icons8-expand-arrow"
          d="M7.85.119,4.272,3.7.695.119A.407.407,0,0,0,.119.695L3.985,4.56a.407.407,0,0,0,.575,0L8.426.695A.407.407,0,1,0,7.85.119Z"
          transform="translate(324.66 286.271) rotate(-90)"
          fill="#888"
          stroke="#888"
          stroke-width="0.3"
        />
      </g>
    </SvgIcon>
  );
}

export function VitalTempIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 38,
    width: 12.376,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="12.376"
      height="38"
      viewBox="0 0 12.376 38"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-thermometer"
        d="M47.224-3a4.042,4.042,0,0,0-4.048,4.048V20.7a.81.81,0,1,0,1.619,0V1.048a2.429,2.429,0,1,1,4.857,0V23.181a3.777,3.777,0,0,0,1,2.563l.027.027a4.637,4.637,0,0,1-.054,6.1,4.594,4.594,0,0,1-6.962-5.991,4.792,4.792,0,0,1,2-1.43,3.536,3.536,0,0,0,2.375-3.319V15.841a.81.81,0,0,0-1.619,0v5.316a1.88,1.88,0,0,1-1.3,1.781,6.214,6.214,0,0,0-2.7,9.768A6.3,6.3,0,0,0,47.062,35h.162a6.149,6.149,0,0,0,4.587-2.024,6.279,6.279,0,0,0,.081-8.257l-.027-.027a2.32,2.32,0,0,1-.593-1.512V1.048A4.042,4.042,0,0,0,47.224-3Zm0,12.635a.8.8,0,0,0-.81.81v1.349a.81.81,0,0,0,1.619,0V10.444A.8.8,0,0,0,47.224,9.635Zm0,17a2.159,2.159,0,1,0,2.159,2.159A2.159,2.159,0,0,0,47.224,26.635Z"
        transform="translate(-41.024 3)"
        fill="#007965"
      />
    </SvgIcon>
  );
}

export function AwrSpeakerIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 64,
    width: 64,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      {...rest}
      sx={rootSx}
    >
      <g
        id="Group_121665"
        data-name="Group 121665"
        transform="translate(-242 -368)"
      >
        <circle
          id="Ellipse_129980"
          data-name="Ellipse 129980"
          cx="32"
          cy="32"
          r="32"
          transform="translate(242 368)"
          fill="#d2ece9"
        />
        <path
          id="icons8-commercial"
          d="M33.259,5.3a2.853,2.853,0,0,0-1.06.152l-16.2,5.516-7.705.591A4.663,4.663,0,0,0,4,16.2v6.417a4.663,4.663,0,0,0,4.291,4.632H7.259l.755,6.789a3.5,3.5,0,0,0,6.974-.394V27.761L16,27.838l16.2,5.516h0a2.991,2.991,0,0,0,3.913-2.786v-7.6a3.375,3.375,0,0,0,0-6.259V8.257h0A3,3,0,0,0,33.6,5.341a2.89,2.89,0,0,0-.345-.039Zm-.024,2.524a.394.394,0,0,1,.341.429V30.569a.394.394,0,0,1-.56.394L16.664,25.387a1.267,1.267,0,0,0-.311-.065l-2.536-.2a1.267,1.267,0,0,0-1.363,1.265v7.26a.963.963,0,0,1-1.919.106L9.652,25.85a1.267,1.267,0,0,0-1.166-1.123,2.1,2.1,0,0,1-1.95-2.106V16.2A2.1,2.1,0,0,1,8.486,14.1l6.5-.5v7.926a1.268,1.268,0,1,0,2.536,0V13.137l15.5-5.274a.51.51,0,0,1,.217-.037Z"
          transform="translate(252.887 378.783)"
          fill="#007965"
        />
      </g>
    </SvgIcon>
  );
}

export function VitalForwardIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 32,
    width: 32,
    // color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...rest}
      sx={rootSx}
    >
      <circle
        id="Ellipse_39211"
        data-name="Ellipse 39211"
        cx="16"
        cy="16"
        r="16"
        fill="#e3e3e3"
      />
      <path
        id="icons8-expand-arrow"
        d="M9.188.139,5,4.327.813.139A.476.476,0,0,0,.139.813L4.664,5.337a.476.476,0,0,0,.673,0L9.861.813A.476.476,0,0,0,9.188.139Z"
        transform="translate(14.356 21.028) rotate(-90)"
        fill="#101010"
        stroke="#101010"
        stroke-width="1"
      />
    </SvgIcon>
  );
}

export function FilterIcon2(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 15.2,
    width: 16,
    color: '#000',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width=" 16"
      height="15.2"
      viewBox="0 0 16 15.2"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-slider"
        d="M15.4,5a1.809,1.809,0,0,0-1.8,1.8V7h-9a.6.6,0,1,0,0,1.2h9v.2a1.8,1.8,0,0,0,3.6,0V8.2h2.2a.6.6,0,1,0,0-1.2H17.2V6.8A1.809,1.809,0,0,0,15.4,5Zm0,1.2a.591.591,0,0,1,.6.6v.7A.6.6,0,0,0,16,7.7v.7a.6.6,0,0,1-1.2,0V7.7a.6.6,0,0,0,0-.195V6.8A.591.591,0,0,1,15.4,6.2ZM8.6,10a1.809,1.809,0,0,0-1.8,1.8V12H4.6a.6.6,0,1,0,0,1.2H6.8v.2a1.8,1.8,0,1,0,3.6,0v-.2h9a.6.6,0,1,0,0-1.2h-9v-.2A1.809,1.809,0,0,0,8.6,10Zm0,1.2a.591.591,0,0,1,.6.6v.7a.6.6,0,0,0,0,.195v.7a.6.6,0,1,1-1.2,0v-.7A.6.6,0,0,0,8,12.5v-.7A.591.591,0,0,1,8.6,11.2Zm6,3.8a1.809,1.809,0,0,0-1.8,1.8V17H4.6a.6.6,0,1,0,0,1.2h8.2v.2a1.8,1.8,0,1,0,3.6,0v-.2h3a.6.6,0,1,0,0-1.2h-3v-.2A1.809,1.809,0,0,0,14.6,15Zm0,1.2a.591.591,0,0,1,.6.6v.7a.6.6,0,0,0,0,.195v.7a.6.6,0,0,1-1.2,0v-.7a.6.6,0,0,0,0-.195v-.7A.591.591,0,0,1,14.6,16.2Z"
        transform="translate(-4 -5)"
      />
    </SvgIcon>
  );
}

export function ExpertRequestIcon(props) {
  const { rootStyle, fill, ...rest } = props;

  const rootSx = {
    height: 24,
    width: 22.8,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="12.256"
      height="12.2"
      viewBox="0 0 24 22.8"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-documents"
        d="M6.7,5A2.7,2.7,0,0,0,4,7.7V25.1a2.7,2.7,0,0,0,2.7,2.7H9.292A3.889,3.889,0,0,1,8.309,26H6.7a.9.9,0,0,1-.9-.9V7.7a.9.9,0,0,1,.9-.9H8.309A3.9,3.9,0,0,1,9.292,5Zm5.4,0A2.714,2.714,0,0,0,9.4,7.7V25.1a2.714,2.714,0,0,0,2.7,2.7H25.3A2.714,2.714,0,0,0,28,25.1v-12a.9.9,0,0,0-.264-.636l-7.2-7.2A.9.9,0,0,0,19.9,5Zm0,1.8H19v4.5A2.714,2.714,0,0,0,21.7,14h4.5V25.1a.886.886,0,0,1-.9.9H12.1a.886.886,0,0,1-.9-.9V7.7A.886.886,0,0,1,12.1,6.8Zm8.7,1.273L24.927,12.2H21.7a.886.886,0,0,1-.9-.9ZM15.1,17a.9.9,0,1,0,0,1.8h7.2a.9.9,0,1,0,0-1.8Zm0,4.2a.9.9,0,1,0,0,1.8h5.4a.9.9,0,1,0,0-1.8Z"
        transform="translate(-4 -5)"
        fill={fill}
      />
    </SvgIcon>
  );
}

export function ExpertMasterIcon(props) {
  const { rootStyle, fill, ...rest } = props;

  const rootSx = {
    height: 19.2,
    width: 24,
    color: '#F44F5A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="12.256"
      height="12.2"
      viewBox="0 0 19.2 24"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-template"
        d="M10.4,4A2.414,2.414,0,0,0,8,6.4V27.1a.9.9,0,1,0,1.8,0V6.4a.586.586,0,0,1,.6-.6H24.8a.586.586,0,0,1,.6.6V27.1a.9.9,0,1,0,1.8,0V6.4A2.414,2.414,0,0,0,24.8,4Zm2.1,3.9a.6.6,0,0,0-.6.6v2.4a.6.6,0,0,0,.6.6H22.7a.6.6,0,0,0,.6-.6V8.5a.6.6,0,0,0-.6-.6Zm.6,6.3a.9.9,0,1,0,0,1.8h9a.9.9,0,1,0,0-1.8Zm0,3.6a.9.9,0,1,0,0,1.8h6.6a.9.9,0,1,0,0-1.8Z"
        transform="translate(-8 -4)"
        fill={fill}
      />
    </SvgIcon>
  );
}

export function CancelAppointmentIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 63.6,
    height: 63.6,
    color: '#d7eae7',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 63.6 63.6"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 5143">
        <path
          data-name="Path 943"
          d="M50.033 25a25.033 25.033 0 1025.033 25.033A25.033 25.033 0 0050.033 25z"
          transform="translate(-14.5 -14.5) translate(-3.266 -3.466)"
          fill="currentColor"
        />
        <path
          data-name="Path 944"
          d="M46.3 16a30.3 30.3 0 1030.3 30.3A30.3 30.3 0 0046.3 16z"
          fill="none"
          stroke="#444b54"
          strokeWidth={3}
          transform="translate(-14.5 -14.5)"
        />
        <path
          data-name="Path 4342"
          d="M33.539 60.068l26.672-26.672m-26.672 0l26.672 26.672"
          fill="none"
          stroke="#3f464e"
          strokeLinecap="round"
          strokeWidth={3}
          transform="translate(-14.5 -14.5)"
        />
      </g>
    </SvgIcon>
  );
}
export function CancelCalenderIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 52,
    width: 52,
    color: '#D4D4D4',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="63.686"
      height="63.686"
      viewBox="0 0 63.686 63.686"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-calendar-delete"
        d="M14.45,6A8.46,8.46,0,0,0,6,14.45v29.9a8.46,8.46,0,0,0,8.45,8.45H29.473a16.8,16.8,0,0,1-1.848-3.9H14.45A4.555,4.555,0,0,1,9.9,44.35V20.28h39v7.345a16.759,16.759,0,0,1,3.9,1.851V14.45A8.46,8.46,0,0,0,44.35,6Zm0,3.9h29.9a4.555,4.555,0,0,1,4.55,4.55v1.93H9.9V14.45A4.555,4.555,0,0,1,14.45,9.9Zm3.9,15.6a3.25,3.25,0,1,0,3.25,3.25,3.25,3.25,0,0,0-3.25-3.25Zm11.05,0a3.25,3.25,0,1,0,3.25,3.25A3.25,3.25,0,0,0,29.4,25.5Zm14.3,3.9A14.3,14.3,0,1,0,58,43.7,14.3,14.3,0,0,0,43.7,29.4Zm-6.5,6.5a1.3,1.3,0,0,1,.919.381L43.7,41.862l5.581-5.581a1.3,1.3,0,0,1,1.838,1.838L45.538,43.7l5.581,5.581a1.3,1.3,0,1,1-1.838,1.838L43.7,45.538l-5.581,5.581a1.3,1.3,0,0,1-1.838-1.838L41.862,43.7l-5.581-5.581A1.3,1.3,0,0,1,37.2,35.9ZM18.35,37.2a3.25,3.25,0,1,0,3.25,3.25,3.25,3.25,0,0,0-3.25-3.25Z"
        transform="matrix(0.966, -0.259, 0.259, 0.966, -7.348, 9.216)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function ScheduleCancelIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 119.89,
    width: 125.57,
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="119.891"
      height="125.574"
      viewBox="0 0 119.891 125.574"
      sx={rootSx}
      {...rest}
    >
      <g id="Schedule-bro" transform="translate(-48.131 -54.767)">
        <g
          id="freepik--background-simple--inject-38"
          transform="translate(168.023 60.722) rotate(93)"
        >
          <path
            id="Path_20580"
            data-name="Path 20580"
            d="M37.539,7S17.165,17.387,7.007,33.385A44.148,44.148,0,0,0,9.994,85.23c12.351,15.282,35.952,13.26,55.715,22.943s41.579,7.685,50.914-12.816S111.877,67.2,109.44,43.471,85.646-15,37.539,7Z"
            fill="#c5e7e1"
          />
          <path
            id="Path_20581"
            data-name="Path 20581"
            d="M37.539,7S17.165,17.387,7.007,33.385A44.148,44.148,0,0,0,9.994,85.23c12.351,15.282,35.952,13.26,55.715,22.943s41.579,7.685,50.914-12.816S111.877,67.2,109.44,43.471,85.646-15,37.539,7Z"
            fill="#fff"
            opacity="0.7"
          />
        </g>
        <path
          id="icons8-calendar-delete"
          d="M12.661,0A12.675,12.675,0,0,0,0,12.661v44.8A12.675,12.675,0,0,0,12.661,70.12H35.17A25.177,25.177,0,0,1,32.4,64.277H12.661A6.825,6.825,0,0,1,5.843,57.46V21.4H64.277V32.4a25.111,25.111,0,0,1,5.843,2.773V12.661A12.675,12.675,0,0,0,57.46,0Zm0,5.843h44.8a6.825,6.825,0,0,1,6.817,6.817v2.891H5.843V12.661A6.825,6.825,0,0,1,12.661,5.843ZM18.5,29.217a4.869,4.869,0,1,0,4.869,4.869A4.869,4.869,0,0,0,18.5,29.217Zm16.556,0a4.869,4.869,0,1,0,4.869,4.869A4.869,4.869,0,0,0,35.06,29.217ZM56.486,35.06A21.426,21.426,0,1,0,77.912,56.486,21.426,21.426,0,0,0,56.486,35.06ZM46.747,44.8a1.941,1.941,0,0,1,1.377.571l8.362,8.362,8.362-8.362A1.947,1.947,0,0,1,67.6,48.124L59.24,56.486,67.6,64.848A1.947,1.947,0,1,1,64.848,67.6L56.486,59.24,48.124,67.6a1.947,1.947,0,0,1-2.754-2.754l8.362-8.362L45.37,48.124A1.948,1.948,0,0,1,46.747,44.8ZM18.5,46.747a4.869,4.869,0,1,0,4.869,4.869A4.869,4.869,0,0,0,18.5,46.747Z"
          transform="matrix(0.966, -0.259, 0.259, 0.966, 60.112, 90.008)"
          fill="#9bbcb6"
        />
      </g>
    </SvgIcon>
  );
}
export function CloseIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 10.543,
    height: 10.534,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.543 16.534"
      sx={rootSx}
      {...rest}
    >
      <path
        d="M22.529 6.97a.972.972 0 00-.679.3l-6.6 6.6-6.6-6.6a.972.972 0 10-1.375 1.373l6.6 6.6-6.6 6.6a.972.972 0 101.374 1.374l6.6-6.6 6.6 6.6a.972.972 0 101.374-1.374l-6.6-6.6 6.6-6.6a.972.972 0 00-.7-1.673z"
        transform="translate(-6.981 -6.97)"
      />
    </SvgIcon>
  );
}

export function DeleteIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12.631}
      {...props}
    >
      <path
        fill="#f44f5a"
        d="M6 0a2.217 2.217 0 0 0-2.185 1.895H1.654a.425.425 0 0 0-.152 0H.474a.474.474 0 1 0 0 .947h.675l.8 8.22a1.743 1.743 0 0 0 1.729 1.57h4.654a1.743 1.743 0 0 0 1.729-1.57l.8-8.22h.675a.474.474 0 1 0 0-.947H10.5a.474.474 0 0 0-.152 0H8.185A2.217 2.217 0 0 0 6 0Zm0 .947a1.252 1.252 0 0 1 1.219.947H4.781A1.252 1.252 0 0 1 6 .947ZM2.1 2.842h7.8l-.787 8.128a.783.783 0 0 1-.786.714H3.673a.784.784 0 0 1-.786-.714Zm2.787 1.572a.474.474 0 0 0-.466.48v4.737a.474.474 0 1 0 .947 0V4.895a.474.474 0 0 0-.481-.48Zm2.211 0a.474.474 0 0 0-.466.48v4.737a.474.474 0 1 0 .947 0V4.895a.474.474 0 0 0-.481-.48Z"
      />
    </svg>
  );
}

export function UploadCloseIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 12.007,
    height: 12,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.007 12"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-delete"
        d="M18.265,6.97a.705.705,0,0,0-.492.217l-4.791,4.791L8.191,7.187a.705.705,0,1,0-1,1l4.791,4.791L7.194,17.766a.705.705,0,1,0,1,1l4.791-4.791,4.791,4.791a.705.705,0,1,0,1-1l-4.791-4.791L18.77,8.185a.705.705,0,0,0-.5-1.214Z"
        transform="translate(-6.981 -6.97)"
        fill="#f44f5a"
      />
    </SvgIcon>
  );
}
export function UserProfileIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 16,
    height: 16.9,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12.2"
      {...rest}
      sx={rootSx}
    >
      <g data-name="User icon" transform="translate(-3973 -5290.9)">
        <path
          data-name="Rectangle 55643"
          transform="translate(3973 5291)"
          fill="none"
          d="M0 0H12V12H0z"
        />
        <path
          d="M3979 5291a3 3 0 102.946 3 2.98 2.98 0 00-2.946-3zm0 .9a2.1 2.1 0 11-2.062 2.1 2.075 2.075 0 012.062-2.1zm-3.542 6.3a1.19 1.19 0 00-1.172 1.194v.456a2.8 2.8 0 001.563 2.419 6.534 6.534 0 003.151.731 6.534 6.534 0 003.151-.731 2.893 2.893 0 001.493-1.969h.071v-.906a1.19 1.19 0 00-1.173-1.194zm0 .9h7.084a.285.285 0 01.289.294v.006h0v.45a1.828 1.828 0 01-1.107 1.631 5.786 5.786 0 01-2.724.619 5.786 5.786 0 01-2.724-.619 1.828 1.828 0 01-1.106-1.631v-.456a.284.284 0 01.288-.294z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={0.2}
        />
      </g>
    </SvgIcon>
  );
}

export function VitalMeterIcon(props) {
  const { rootStyle } = props;

  const rootSx = {
    width: 15,
    height: 14,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 15.806 14.25"
    >
      <path
        d="M2.264.125A2.148 2.148 0 00.125 2.264v9.722a2.148 2.148 0 002.139 2.139h11.278a2.148 2.148 0 002.139-2.139V2.264A2.148 2.148 0 0013.542.125zm0 1.167h11.278a.964.964 0 01.972.972v9.722a.964.964 0 01-.972.972H2.264a.964.964 0 01-.972-.972V8.292h.972a.581.581 0 00.5-.283l.59-.982 1.1 2.475a.584.584 0 00.531.346.6.6 0 00.533-.342l1.348-2.967 1.459 4.086a.582.582 0 00.513.385h.036a.584.584 0 00.522-.322l1.395-2.789h.418a.972.972 0 100-1.167h-.779a.583.583 0 00-.522.322l-.944 1.889-1.485-4.158a.583.583 0 00-.525-.386.576.576 0 00-.555.341l-1.407 3.1-1.029-2.315a.583.583 0 00-1.033-.063l-.997 1.663h-.641V2.264a.964.964 0 01.972-.972z"
        fill="#0d1824"
        stroke="#0d1824"
        strokeWidth={0.25}
      />
    </SvgIcon>
  );
}

export function ReportPatientIcon(props) {
  const { rootStyle } = props;
  const rootSx = {
    width: 12,
    height: 16,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 12.8 16"
    >
      <path
        data-name="icons8-document (1)"
        d="M9.8 4A1.809 1.809 0 008 5.8v12.4A1.809 1.809 0 009.8 20H19a1.809 1.809 0 001.8-1.8V9.8a.6.6 0 00-.176-.424l-.006-.006-5.194-5.194A.6.6 0 0015 4zm0 1.2h4.6v3.4a1.809 1.809 0 001.8 1.8h3.4v7.8a.591.591 0 01-.6.6H9.8a.591.591 0 01-.6-.6V5.8a.591.591 0 01.6-.6zm5.8.848L18.752 9.2H16.2a.591.591 0 01-.6-.6zM11.8 12.4a.6.6 0 100 1.2H17a.6.6 0 100-1.2zm0 2.8a.6.6 0 100 1.2h3.6a.6.6 0 100-1.2z"
        transform="translate(-8 -4)"
        fill="#0d1824"
      />
    </SvgIcon>
  );
}

export function DoctorMedicalRepIcon(props) {
  const { rootStyle } = props;
  const rootSx = {
    width: 16,
    height: 14,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 16.583 14.25"
    >
      <path
        data-name="icons8-heart-with-pulse (1)"
        d="M4.597.125C2.557.125.125.969.125 4.986a3.685 3.685 0 00.1.968c0-.007 1.166 0 1.166 0a5.125 5.125 0 01-.1-.972c0-2.555 1.019-3.694 3.306-3.694a3.707 3.707 0 013.19 1.839.584.584 0 001.009 0 3.707 3.707 0 013.19-1.839c2.286 0 3.306 1.139 3.306 3.694 0 4.485-5.785 7.363-7 7.918a15.912 15.912 0 01-5.63-4.225H1.236c2.126 3.427 6.588 5.3 6.834 5.4a.586.586 0 00.442 0c.324-.133 7.946-3.326 7.946-9.1 0-4.006-2.433-4.85-4.472-4.85a4.877 4.877 0 00-3.694 1.709A4.877 4.877 0 004.597.125zm2.715 3.888a.577.577 0 00-.523.343l-1.407 3.1-1.029-2.318a.583.583 0 00-.5-.345h-.028a.58.58 0 00-.5.283l-1 1.661H1.097a.584.584 0 100 1.167h1.556a.581.581 0 00.5-.283l.59-.982 1.1 2.475a.584.584 0 00.531.346.6.6 0 00.533-.342l1.348-2.967 1.461 4.089a.582.582 0 00.513.385h.036a.584.584 0 00.522-.322l1.395-2.789h.421a.972.972 0 100-1.165h-.782a.583.583 0 00-.522.322L9.355 8.56 7.87 4.402a.582.582 0 00-.525-.386z"
        fill="#0e1824"
        stroke="#0c151f"
        strokeWidth={0.25}
      />
    </SvgIcon>
  );
}
export function ReportEyeIcon(props) {
  const { rootStyle } = props;
  const rootSx = {
    width: 14,
    height: 8,
    ...rootStyle,
  };
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" sx={rootSx} viewBox="0 0 14 8">
      <path
        d="M7 9a7.263 7.263 0 00-6.987 5.306.438.438 0 10.848.218A6.422 6.422 0 017 9.878a6.433 6.433 0 016.143 4.646.438.438 0 10.848-.218A7.272 7.272 0 007 9zm0 2.342a2.829 2.829 0 102.819 2.829A2.83 2.83 0 007 11.342zm0 .878a1.951 1.951 0 11-1.944 1.951A1.941 1.941 0 017 12.22z"
        transform="translate(.001 -9)"
        fill="#0e1824"
      />
    </SvgIcon>
  );
}
export function ReportRoundIcon(props) {
  const { rootStyle } = props;
  const rootSx = {
    width: 28,
    height: 28,
    ...rootStyle,
  };
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" sx={rootSx} viewBox="0 0 28 28">
      <g data-name="Group 4409" transform="translate(-62 -454)">
        <circle
          data-name="Ellipse 39340"
          cx={14}
          cy={14}
          r={14}
          transform="translate(62 454)"
          fill="#e3e3e3"
        />
        <path
          d="M9.8 4A1.809 1.809 0 008 5.8v12.4A1.809 1.809 0 009.8 20H19a1.809 1.809 0 001.8-1.8V9.8a.6.6 0 00-.176-.424l-.006-.006-5.194-5.194A.6.6 0 0015 4zm0 1.2h4.6v3.4a1.809 1.809 0 001.8 1.8h3.4v7.8a.591.591 0 01-.6.6H9.8a.591.591 0 01-.6-.6V5.8a.591.591 0 01.6-.6zm5.8.848L18.752 9.2H16.2a.591.591 0 01-.6-.6zM11.8 12.4a.6.6 0 100 1.2H17a.6.6 0 100-1.2zm0 2.8a.6.6 0 100 1.2h3.6a.6.6 0 100-1.2z"
          transform="translate(62 456)"
          fill="#0e1824"
        />
      </g>
    </SvgIcon>
  );
}

export function ChatMessageIcon(props) {
  const { rootStyle } = props;
  const rootSx = {
    width: 20,
    height: 20,
    color: '#0E1824',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 20.062 20.062"
    >
      <path
        d="M14.031 4A10.043 10.043 0 004 14.029a9.938 9.938 0 001.134 4.547L4.047 22.47a1.28 1.28 0 001.546 1.546l3.9-1.087a9.936 9.936 0 004.542 1.132A10.031 10.031 0 0014.031 4zm0 1.5a8.527 8.527 0 11-4.142 15.98.752.752 0 00-.568-.068l-3.7 1.033 1.034-3.7a.752.752 0 00-.068-.569A8.522 8.522 0 0114.031 5.5zm-4.263 6.021a.752.752 0 100 1.5h8.527a.752.752 0 100-1.5zm0 3.511a.752.752 0 100 1.5h6.52a.752.752 0 100-1.5z"
        transform="translate(-37.988 3.016) translate(33.988 -7.014)"
        fill="CurrentColor"
        data-name="Group 121373"
      />
    </SvgIcon>
  );
}

export function TabpadIcon(props) {
  const { rootStyle } = props;
  const rootSx = {
    width: 22,
    height: 19,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 22.014 19.812"
    >
      <path
        d="M14.007 4a3.149 3.149 0 00-3.145 3.128v1.043h-5.5A2.364 2.364 0 003 10.517v10.949a2.364 2.364 0 002.359 2.346h17.3a2.364 2.364 0 002.359-2.346V10.517a2.364 2.364 0 00-2.359-2.346h-5.5V7.128A3.149 3.149 0 0014.007 4zm0 1.564a1.557 1.557 0 011.572 1.564v2.346a.25.25 0 01-.262.261H12.7a.25.25 0 01-.262-.261V7.128a1.557 1.557 0 011.569-1.564zM5.359 9.735h5.53A1.841 1.841 0 0012.7 11.3h2.621a1.841 1.841 0 001.808-1.564h5.53a.772.772 0 01.786.782v10.948a.772.772 0 01-.786.782h-17.3a.772.772 0 01-.786-.782V10.517a.772.772 0 01.786-.782zm3.931 3.128a1.564 1.564 0 101.572 1.564 1.568 1.568 0 00-1.572-1.564zm6.027 1.043a.782.782 0 100 1.564h5.241a.782.782 0 100-1.564zm-7.862 3.128a.784.784 0 00-.786.782c0 .782 0 2.346 2.568 2.346h.1c2.568 0 2.568-1.564 2.568-2.346a.784.784 0 00-.786-.782zm7.862.521a.782.782 0 100 1.564h5.241a.782.782 0 100-1.564z"
        transform="translate(-3 -4)"
        fill="#fff"
      />
    </SvgIcon>
  );
}

export function FemaleIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 16,
    width: 16.4,
    // color: 'orangeTints.600',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.634 16.4"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M5.817.2a5.616 5.616 0 00-.511 11.208v1.728H3.434a.511.511 0 100 1.021h1.872v1.532a.511.511 0 101.021 0v-1.532H8.2a.511.511 0 100-1.021H6.328v-1.728A5.616 5.616 0 005.817.2zm0 1.021a4.6 4.6 0 11-4.6 4.6 4.588 4.588 0 014.6-4.6z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.4}
      />
    </SvgIcon>
  );
}
export function MaleIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 16.4,
    width: 16.4,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.4 16.4"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M10.224.2a.578.578 0 100 1.157h3.938L10.619 4.9l-.023.026a6.419 6.419 0 10.819.812l.022-.02 3.606-3.606v4.065a.578.578 0 101.157 0v-5.4a.578.578 0 00-.578-.578zM6.561 4.634a5.2 5.2 0 11-5.2 5.2 5.2 5.2 0 015.2-5.2z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.4}
      />
    </SvgIcon>
  );
}
export function DayIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 16,
    height: 14,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 14"
      {...rest}
      sx={rootSx}
    >
      <path d="M7.991 0a.613.613 0 00-.262.063.6.6 0 00-.207.169l-1.743 1.7a.583.583 0 00-.135.189.568.568 0 000 .452.582.582 0 00.131.192.6.6 0 00.2.127.615.615 0 00.464 0 .6.6 0 00.195-.131L7.4 2v2.09a.569.569 0 00.043.226.582.582 0 00.129.192.6.6 0 00.2.128.615.615 0 00.463 0 .6.6 0 00.2-.128.582.582 0 00.129-.192.569.569 0 00.036-.228V2l.775.753a.6.6 0 00.195.131.615.615 0 00.464 0 .6.6 0 00.2-.127.582.582 0 00.131-.192.567.567 0 000-.452.581.581 0 00-.135-.189L8.475.229a.6.6 0 00-.214-.17.614.614 0 00-.27-.059zm0 5.828A.608.608 0 007.57 6a.574.574 0 00-.169.414v1.17a.569.569 0 00.043.226.581.581 0 00.129.19.6.6 0 00.2.128.615.615 0 00.463 0A.6.6 0 008.427 8a.581.581 0 00.129-.192.569.569 0 00.044-.224V6.419a.569.569 0 00-.044-.228A.582.582 0 008.424 6a.6.6 0 00-.2-.128.615.615 0 00-.233-.044zM2.767 7.935a.612.612 0 00-.335.1.586.586 0 00-.221.264.568.568 0 00-.031.339.578.578 0 00.169.3l.851.822a.6.6 0 00.195.126.616.616 0 00.459 0 .6.6 0 00.195-.126.582.582 0 00.13-.189.568.568 0 000-.446.582.582 0 00-.13-.189L3.2 8.112a.6.6 0 00-.2-.131.614.614 0 00-.233-.046zm10.448 0a.607.607 0 00-.412.176l-.847.824a.584.584 0 00-.13.189.569.569 0 000 .446.584.584 0 00.13.189.6.6 0 00.195.126.616.616 0 00.459 0 .6.6 0 00.19-.125l.847-.824a.578.578 0 00.17-.3.568.568 0 00-.036-.343.587.587 0 00-.229-.264.612.612 0 00-.337-.094zM8 9.332a4.348 4.348 0 00-4.384 4.049.568.568 0 00.032.227.579.579 0 00.119.2.6.6 0 00.188.138.615.615 0 00.461.023.6.6 0 00.2-.118.583.583 0 00.14-.184.569.569 0 00.056-.222A3.147 3.147 0 018 10.5a3.147 3.147 0 013.187 2.944.569.569 0 00.056.222.584.584 0 00.14.184.6.6 0 00.2.118.616.616 0 00.461-.023.6.6 0 00.188-.138.578.578 0 00.119-.2.568.568 0 00.032-.227A4.348 4.348 0 008 9.332zm-7.392 3.5a.614.614 0 00-.232.042.6.6 0 00-.2.126.582.582 0 00-.132.19.568.568 0 000 .45.582.582 0 00.132.19.6.6 0 00.2.126.614.614 0 00.232.042h1.2a.614.614 0 00.232-.042.6.6 0 00.2-.126.582.582 0 00.132-.19.568.568 0 000-.45.582.582 0 00-.136-.19.6.6 0 00-.2-.126.614.614 0 00-.232-.042zm13.586 0a.614.614 0 00-.232.042.6.6 0 00-.2.126.582.582 0 00-.132.19.568.568 0 000 .45.582.582 0 00.132.19.6.6 0 00.2.126.614.614 0 00.232.042h1.2a.614.614 0 00.232-.042.6.6 0 00.2-.126.582.582 0 00.132-.19.568.568 0 000-.45.582.582 0 00-.132-.19.6.6 0 00-.2-.126.614.614 0 00-.232-.042z" />
    </SvgIcon>
  );
}
export function NightIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 13.273,
    height: 13.273,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.273 13.273"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M6.418 1.394a.5.5 0 00-.189.03 6.892 6.892 0 00-4.562 6.413A6.813 6.813 0 0014.91 10.1a.5.5 0 00-.737-.594 5.276 5.276 0 01-2.839.822 5.329 5.329 0 01-4.511-8.167.5.5 0 00-.4-.767zm-1.08 1.641A6.241 6.241 0 005 5a6.343 6.343 0 006.333 6.333A6.239 6.239 0 0013.3 11a5.766 5.766 0 11-7.96-7.96z"
        transform="translate(-1.667 -1.394)"
      />
    </SvgIcon>
  );
}
export function OthersIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 16,
    width: 16,
    // color: 'orangeTints.600',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.054 16"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M6.57 3.984a.585.585 0 00-.579.666v2.656a.585.585 0 101.17 0V5.988L8.675 7.5l-.562.562a.585.585 0 10.827.827l.56-.56 1.131 1.131a3.006 3.006 0 001.8 4.945v2.459h-1.17a.585.585 0 100 1.17h1.17V19.4a.585.585 0 101.17 0v-1.366h1.17a.585.585 0 100-1.17H13.6V14.4a3.006 3.006 0 001.8-4.945l3.471-3.471v1.322a.585.585 0 101.17 0V4.65a.585.585 0 00-.66-.659h-2.662a.585.585 0 100 1.17h1.318L14.49 8.707a3.027 3.027 0 00-1.477-.426 3.027 3.027 0 00-1.477.426L10.33 7.5l.562-.562a.585.585 0 10-.827-.828l-.565.564-1.511-1.513h1.318a.585.585 0 100-1.17H6.65a.585.585 0 00-.08-.006zm6.443 5.467a1.95 1.95 0 11-1.95 1.95 1.942 1.942 0 011.95-1.949z"
        transform="translate(-5.986 -3.984)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function BpIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 41,
    width: 41,
    color: '#db6464',
    ...rootStyle,
  };
  return (
    <SvgIcon
      data-name="Group 5615"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 41 41"
      {...rest}
      sx={rootSx}
    >
      <g
        data-name="Rectangle 44700"
        fill="#fff0f0"
        stroke="#f5dcdc"
        strokeWidth={1}
      >
        <rect width={41} height={41} rx={4} stroke="none" />
        <rect x={0.5} y={0.5} width={40} height={40} rx={3.5} fill="none" />
      </g>
      <path
        data-name="Path 4862"
        d="M19.508 11a2.5 2.5 0 012.5 2.5v8a2.5 2.5 0 01-2.5 2.5h-2v3.5a2.5 2.5 0 002.5 2.5h4a2.5 2.5 0 002.5-2.5V25A3.778 3.778 0 0123 21a4.1 4.1 0 011.9-3.555l-.4-2.363a.5.5 0 01.5-.582h3a.5.5 0 01.493.582l-.4 2.363A4.1 4.1 0 0130 21a3.972 3.972 0 01-2.5 3.831V27.5A3.5 3.5 0 0124 31h-4a3.5 3.5 0 01-3.5-3.5V24h-1.833a3 3 0 11-2.652-5.325V13.5a2.5 2.5 0 012.497-2.5zm0 1h-5a1.5 1.5 0 00-1.5 1.5v5a2.995 2.995 0 012.597 4.5h3.9a1.5 1.5 0 001.5-1.5v-8a1.5 1.5 0 00-1.5-1.5zm7.9 3.5h-1.815l.262 1.571a2.953 2.953 0 011.292 0zM26.5 18a2.787 2.787 0 00-2.5 3 2.787 2.787 0 002.5 3 2.787 2.787 0 002.5-3 2.787 2.787 0 00-2.5-3zm-13.462 1.5h-.024a1.958 1.958 0 10.024 0zm-.01.5a.5.5 0 01.485.5V22a.5.5 0 01-.5.5h-1a.5.5 0 010-1h.5v-1a.5.5 0 01.514-.5z"
        fill="currentColor"
        stroke="#db6464"
        strokeWidth={0.2}
      />
    </SvgIcon>
  );
}
export function HeightIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 40,
    width: 41,
    color: '#98c645',
    ...rootStyle,
  };
  return (
    <SvgIcon
      data-name="Group 5615"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 41"
      {...rest}
      sx={rootSx}
    >
      <g
        data-name="Rectangle 44700"
        fill="#f7ffe6"
        stroke="#eaf5d3"
        strokeWidth={1}
      >
        <rect width={40} height={41} rx={4} stroke="none" />
        <rect x={0.5} y={0.5} width={39} height={40} rx={3.5} fill="none" />
      </g>
      <path
        data-name="icons8-length 1"
        d="M14.753 2.027a2.964 2.964 0 00-2.1.866l-9.76 9.771a2.932 2.932 0 00.047 4.255l4.234 4.241a2.99 2.99 0 004.205 0l9.76-9.771a3 3 0 000-4.21l-4.283-4.286a2.964 2.964 0 00-2.103-.866zm0 1.95a.977.977 0 01.685.333l4.283 4.29a.877.877 0 010 1.375l-9.76 9.771a.874.874 0 01-1.373 0l-4.3-4.31-.025-.023a.927.927 0 01.037-1.331l1.224-1.226 3.033 3.112 1.443-1.4-3.053-3.13L8.52 9.864l1.574 1.694 1.467-1.367-1.623-1.747L11.55 6.83l3.1 3.1 1.416-1.42-3.1-3.1 1.1-1.1a.982.982 0 01.687-.332z"
        transform="translate(8 8.474)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function WeightIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 41,
    width: 41,
    color: '#e3984d',
    ...rootStyle,
  };
  return (
    <SvgIcon
      data-name="Group 5615"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 41 41"
      {...rest}
      sx={rootSx}
    >
      <g
        data-name="Rectangle 44700"
        fill="#fff8f0"
        stroke="#f5e9dc"
        strokeWidth={1}
      >
        <rect width={41} height={41} rx={4} stroke="none" />
        <rect x={0.5} y={0.5} width={40} height={40} rx={3.5} fill="none" />
      </g>
      <path
        d="M12 2a2.772 2.772 0 00-2.081.888 2.83 2.83 0 00-.7 1.89 2.937 2.937 0 00.238 1.111H6.21a3.066 3.066 0 00-3.036 2.705l-1.153 10A3.072 3.072 0 005.056 22h13.887a3.072 3.072 0 003.037-3.4l-1.154-10a3.065 3.065 0 00-3.035-2.705H14.54a2.938 2.938 0 00.238-1.111 2.83 2.83 0 00-.7-1.89A2.772 2.772 0 0012 2zm0 1.667a1 1 0 01.835.328 1.251 1.251 0 010 1.567 1 1 0 01-.835.327 1 1 0 01-.835-.328 1.251 1.251 0 010-1.567A1 1 0 0112 3.667zM6.21 7.556h11.581a1.379 1.379 0 011.379 1.23l1.154 10a1.375 1.375 0 01-1.381 1.548H5.056a1.373 1.373 0 01-1.38-1.547l1.153-10A1.38 1.38 0 016.21 7.556zm1.508 3.333a.7.7 0 00-.694.694v5.278a.694.694 0 101.389 0V15.2l1.81 2.116a.694.694 0 101.055-.9l-1.872-2.194 1.871-2.187a.694.694 0 00-1.055-.9l-1.81 2.116v-1.668a.7.7 0 00-.694-.694zm7.045 0A3.092 3.092 0 0012 14.222a3.092 3.092 0 002.764 3.333 2.454 2.454 0 002.158-1.255.692.692 0 00.078-.318v-1.343a.7.7 0 00-.694-.694h-.833a.694.694 0 100 1.389h.139v.441a1.074 1.074 0 01-.847.393c-.745 0-1.375-.891-1.375-1.944s.63-1.944 1.375-1.944a1.067 1.067 0 01.922.5.694.694 0 101.185-.723 2.453 2.453 0 00-2.109-1.168z"
        transform="translate(9 9)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function BmiBgIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 41,
    width: 41,
    color: '#4f7bd6',
    ...rootStyle,
  };

  return (
    <SvgIcon
      data-name="Group 5615"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 41 41"
      {...rest}
      sx={rootSx}
    >
      <g
        data-name="Rectangle 44700"
        fill="#f0f4ff"
        stroke="#dce3f5"
        strokeWidth={1}
      >
        <rect width={41} height={41} rx={4} stroke="none" />
        <rect x={0.5} y={0.5} width={40} height={40} rx={3.5} fill="none" />
      </g>
      <path
        data-name="Path 4861"
        d="M12.27 11A1.307 1.307 0 0011 12.333v17.334A1.307 1.307 0 0012.27 31h16.508a1.307 1.307 0 001.27-1.333v-3.049A1.326 1.326 0 0031 25.333v-2a1.325 1.325 0 00-.952-1.285v-9.715A1.307 1.307 0 0028.778 11zm0 .667h16.508a.644.644 0 01.635.667V22h-.586a.272.272 0 00-.1 0H27.24a.272.272 0 00-.1 0h-1.488a.272.272 0 00-.1 0h-1.487a.272.272 0 00-.1 0h-1.487a.272.272 0 00-.1 0H20.89a.272.272 0 00-.1 0H19.3a.272.272 0 00-.1 0h-1.484a.271.271 0 00-.1 0h-3.759a.31.31 0 00-.224.1.342.342 0 00-.093.236v4a.342.342 0 00.093.236.31.31 0 00.224.1h15.556v3a.644.644 0 01-.635.667H12.27a.644.644 0 01-.635-.667V12.333a.644.644 0 01.635-.666zm8.249 2a.3.3 0 00-.059.007 5.413 5.413 0 00-3.38 1.064 3.613 3.613 0 00-.967 1.118.349.349 0 00-.013.266l.952 2.667a.332.332 0 00.116.157.307.307 0 00.181.054H23.7a.307.307 0 00.181-.059.332.332 0 00.119-.157l.952-2.667a.349.349 0 00-.013-.266 3.614 3.614 0 00-.967-1.118 5.413 5.413 0 00-3.381-1.064.3.3 0 00-.072-.007zm-.312.684v.988a.35.35 0 00.023.129.336.336 0 00.068.11.318.318 0 00.1.073.3.3 0 00.245 0 .316.316 0 00.1-.073.336.336 0 00.069-.11.348.348 0 00.023-.129v-.993a5.262 5.262 0 011.863.4l-.259.816a.348.348 0 00-.016.129.345.345 0 00.033.126.332.332 0 00.076.1.314.314 0 00.108.064.3.3 0 00.243-.018.32.32 0 00.1-.08.339.339 0 00.061-.113l.229-.723c.112.072.218.144.311.217a2.617 2.617 0 01.71.773l-.819 2.294h-2.264l.248-1.562a.349.349 0 00.012-.155.342.342 0 00-.056-.144.322.322 0 00-.113-.1.305.305 0 00-.144-.037.31.31 0 00-.224.1.342.342 0 00-.093.236l-.794 1.667h-2.478l-.819-2.296a2.617 2.617 0 01.71-.773c.093-.073.2-.146.311-.217l.229.722a.338.338 0 00.061.113.32.32 0 00.1.08.3.3 0 00.243.018.314.314 0 00.108-.064.332.332 0 00.076-.1.349.349 0 00.012-.258l-.259-.816a5.262 5.262 0 011.865-.399zm-7.62 1.316A.334.334 0 1012.9 16a.327.327 0 00-.313-.333zm1.27 0a.334.334 0 10.318.333.327.327 0 00-.318-.333zm1.27 0a.334.334 0 10.317.333.327.327 0 00-.317-.333zm10.794 0a.334.334 0 10.317.333.327.327 0 00-.317-.333zm1.27 0a.334.334 0 10.317.333.327.327 0 00-.318-.333zm1.27 0a.334.334 0 10.317.333.327.327 0 00-.318-.333zm-14.286 7h.952v1a.342.342 0 00.093.236.31.31 0 00.224.1.334.334 0 010 .667.31.31 0 00-.224.1.342.342 0 00-.093.23v1h-.952zm1.587 0h1.587V24a.348.348 0 00.023.129.336.336 0 00.069.11.319.319 0 00.1.073.3.3 0 00.245 0 .319.319 0 00.1-.073.336.336 0 00.069-.11.348.348 0 00.029-.129v-1.333h.952v.667a.348.348 0 00.023.129.336.336 0 00.069.11.317.317 0 00.1.074.3.3 0 00.245 0 .318.318 0 00.1-.074.337.337 0 00.068-.11.347.347 0 00.023-.129v-.667h.952V24a.348.348 0 00.023.129.337.337 0 00.069.11.318.318 0 00.1.073.3.3 0 00.245 0 .32.32 0 00.1-.073.337.337 0 00.068-.11.348.348 0 00.038-.129v-1.333h.952v.667a.347.347 0 00.023.129.337.337 0 00.068.11.317.317 0 00.1.074.3.3 0 00.245 0 .318.318 0 00.1-.074.337.337 0 00.068-.11.347.347 0 00.023-.129v-.667h.962V24a.348.348 0 00.023.129.337.337 0 00.069.11.318.318 0 00.1.073.3.3 0 00.245 0 .32.32 0 00.1-.073.337.337 0 00.069-.11.348.348 0 00.027-.129v-1.333h.952v.667a.347.347 0 00.023.129.337.337 0 00.068.11.317.317 0 00.1.074.3.3 0 00.245 0 .318.318 0 00.1-.074.337.337 0 00.069-.11.347.347 0 00.023-.129v-.667h.952V24a.348.348 0 00.023.129.337.337 0 00.068.11.318.318 0 00.1.073.3.3 0 00.245 0 .32.32 0 00.1-.073.337.337 0 00.069-.11.348.348 0 00.038-.129v-1.333h.952v.667a.347.347 0 00.023.129.337.337 0 00.069.11.317.317 0 00.1.074.3.3 0 00.245 0 .318.318 0 00.1-.074.337.337 0 00.069-.11.347.347 0 00.023-.129v-.667h.635a.646.646 0 01.635.667v2a.646.646 0 01-.629.666H15.762v-.805a.9.9 0 000-1.723z"
        fill="currentColor"
        stroke="#4f7bd6"
        strokeWidth={0.2}
      />
    </SvgIcon>
  );
}
